module.exports = __webpack_public_path__ + "img/fay-pretty.274c40c4.jpg";